import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "MonthRangeDatePicker" })((_theme) => ({
  dateRangeField: {
    width: 300,
    height: 40,
    "& .ant-picker-input > input": {
      fontSize: 16,
      fontWeight: 600,
    },
  },
  dateRangePresets: {
    width: 180,
    height: 40,
  },
}));
